import getSlug from 'speakingurl';
import { has } from 'lodash';
/**
* Produces an SEO-friendly URL. This function attempts to emulate the same functionality
* as the OAS backend
* @param {string} descriptor - The string which will be made into a slug. Can be a lot title, catalog title, house name, etc.
* @param opts can contain a property "retainChars" which is an array of charracters to not be transformed
* @return {string} SEO-friendly slug in the form of seo-friendly-url-slug
*/
function seoFriendlyUrl(descriptor, opts) {
  if (!descriptor) {
    return '';
  }

  /**
   * (dyouberg)
   * INV-4933: Our categories such as "Men's Jewelry" and "Women's Watches" were being set to
   * men-s-jewelry and women-s-watches by getSlug. As per Steve P. this is an SEO
   * hit so let's just remove the ' character and nip it in the bud.
   */
  const descriptorString = descriptor.toString().replace(/['’]/g, '');

  const custom = {
    '&': '-',
    '|': '-',
    '(': '-',
    ')': '-',
    '\'': '-',
    $: '-',
    '*': '-',
    '.': '-',
    '!': '-',
    ',': '-',
  };

  if (opts && opts.hash) {
    Object.assign(opts, opts.hash);
  }

  if (has(opts, 'retainChars') && opts.retainChars) {
    opts.retainChars.forEach((newChar) => {
      custom[newChar] = newChar;
    });
  }

  const maintainCase = has(opts, 'maintainCase') && opts.maintainCase;
  const mark = true;

  const options = {
    custom,
    maintainCase,
    mark,
  };

  let slugVal = getSlug(descriptorString, options);
  if (slugVal.length > 50) {
    slugVal = slugVal.substr(0, 49);
  }

  return slugVal;
}

export default seoFriendlyUrl;
